import { render, staticRenderFns } from "./viewPending.vue?vue&type=template&id=25b06fe1&scoped=true&"
import script from "./viewPending.vue?vue&type=script&lang=js&"
export * from "./viewPending.vue?vue&type=script&lang=js&"
import style0 from "./viewPending.vue?vue&type=style&index=0&id=25b06fe1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25b06fe1",
  null
  
)

export default component.exports